import { reactive, ref } from 'vue'
import { useStore } from 'vuex'
import axios from 'axios'

const ENV = require('../../env.js')()

const instance = axios.create({
  // baseURL: 'http://carrefour-dev-redenvelope-api.cloud-softwares.com/api/',
  // baseURL: 'http://10.1.1.28:22488/api/',
  // baseURL: env.SERVER_URL,
  timeout: 3000
})

// interceptor
export const loadingCounter = ref(0)

instance.interceptors.request.use(
  config => {
    loadingCounter.value++
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
instance.interceptors.response.use(
  response => {
    loadingCounter.value--
    return response
  },
  error => {
    loadingCounter.value--
    return Promise.reject(error?.response?.data ?? error) // 返回接口返回的错误信息
  }
)

// function

export function setHeaders(name: string, value: string) {
  instance.defaults.headers.common[name] = value
}
export function setRedenvelopeBaseUrl() {
  instance.defaults.baseURL = ENV.REDENVELOPE_SERVER_URL
}
export function setAppBaseUrl() {
  instance.defaults.baseURL = ENV.APP_SERVER_URL
}

// api

export function useAxiosRecord(type: number, groupId: string) {
  const store = useStore()
  const state = reactive({
    result: [],
    groupId,
    type
  })
  async function post() {
    const { data: jsonData } = await instance.post('/game/v1/record', null, {
      params: { type: state.type, group_id: state.groupId }
    })
    const { data, statusCode } = jsonData
    const { content } = data
    state.result = content
    // store.state.status.code = statusCode
  }
  function init() {
    post()
  }
  init()
  return {
    state
  }
}

export function useAxiosPlaying(name: string, member_card: string) {
  return instance.post('/game/v1/playing3', {
    name,
    member_card
  })
}

interface resultFormat {
  banner_url: string
  pointer_url: string
  spinner_url: string
  frame_url: string
  play_times: string | number
  game_rule: string
  share_url: string
  share_wording: string
  game_name: string
  mission_status: number
  group_id: string
}

export function useAxiosGameInfo() {
  const store = useStore()
  const result: resultFormat = reactive({
    banner_url: '',
    pointer_url: '',
    spinner_url: '',
    frame_url: '',
    play_times: '',
    game_rule: '',
    share_url: '',
    share_wording: '',
    game_name: '',
    mission_status: 0,
    group_id: ''
  })

  async function init(type: number = 1) {
    const { data: jsonData } = await instance.get('/game/v1/gameinfo', {
      headers: { type }
    })
    // console.warn(jsonData)
    // const FAKE = {"serverTime":"2022-07-20 14:17:43","statusCode":"0000","statusMessage":" successful execution","data":{"group_id":"1","game_name":"test","game_rule":"<p>test<\/p>","token":"MVhjkI2fFqXyAuz6MFacVlUnagXT2aaFlb1MeNm%2BXK5mWQwzq630zg%3D%3D","trans_start":"2022-07-19 11:00:00","trans_end":"2029-12-31 06:00:00","banner_url":"https:\/\/c4app-uat.carrefour.com.tw\/file\/game\/_1658198435892222.png","frame_url":"https:\/\/c4app-uat.carrefour.com.tw\/file\/game\/_1658198435279330.png","spinner_url":"https:\/\/c4app-uat.carrefour.com.tw\/file\/game\/_1658198436639686.png","pointer_url":"https:\/\/c4app-uat.carrefour.com.tw\/file\/game\/_1658198436391644.png","share_url":"https:\/\/c4app-uat-redpacket.carrefour.com.tw\/api\/game\/v1\/check?gameId=6mxWRaX9\/4zeEjNfcihQ6A==","share_wording":"\u6211\u5728\u5bb6\u6a02\u798fAPP\u62bd\u4e2d\u5927\u734e\u4e86\uff01\u5929\u5929\u767b\u5165\u5bb6\u6a02\u798fAPP\u73a9\u8f49\u76e4\u62bd\u597d\u79ae","statusCodeType":"game_v1","mission_status":0,"play_times":10}}
    // const { data } = FAKE
    const { data } = jsonData
    result.banner_url = data.banner_url
    result.frame_url = data.frame_url
    result.pointer_url = data.pointer_url
    result.spinner_url = data.spinner_url
    result.play_times = data.play_times
    result.game_rule = data.game_rule
    result.share_url = data.share_url
    result.game_name = data.game_name
    result.share_wording = data.share_wording
    result.mission_status = data.mission_status
    result.group_id = data.group_id
    // store.state.status.code = statusCode
  }

  return { init, result }
}

interface invoiceInfoSchema {
  banner_url: string
  event_wording: string
  event_id: number
}
export function useAxiosInvoiceInfo() {
  const result: invoiceInfoSchema = reactive({
    event_id: 0,
    banner_url: '',
    event_wording: ''
  })
  const store = useStore()
  async function get() {
    const { data } = await instance.get('/event_invoice/info')
    const { statusCode, statusMessage } = data
    setStatus(statusCode, statusMessage)
    result.banner_url = data.data.banner_url
    result.event_wording = data.data.event_wording
  }
  async function post(id: number) {
    // const { data } = await instance.post('/event_invoice/reward', {
    //   event_id: id
    // })
    // const { statusCode, statusMessage } = data
    // setStatus(statusCode, statusMessage)
    return new Promise((resolve, reject) => {
      instance
        .post('/event_invoice/reward', {
          event_id: id
        })
        .then(jsonData => {
          const { data } = jsonData
          const { statusCode, statusMessage } = data
          setStatus(statusCode, statusMessage)
          if (statusCode === '0000') {
            resolve(data)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  function setStatus(statusCode: string, statusMessage: string) {
    store.dispatch('setInvoiceStatus', {
      code: statusCode,
      message: statusMessage
    })
  }
  return { get, post, result }
}
